import { io, type Socket } from 'socket.io-client';

export type GameMode = 'sketch' | 'who-said' | 'story' | 'blind' | 'marriage';

const sharedOptions = {
  path: '/socket.io',
  autoConnect: false,
  transports: ['polling', 'websocket'],
  tryAllTransports: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  reconnectionDelayMax: 5000,
  timeout: 20000
};

const sketchSocket = io(sharedOptions);
const whoSaidSocket = io('/who-said', sharedOptions);
const storySocket = io('/story', sharedOptions);
const blindSocket = io('/blind', sharedOptions);
const marriageSocket = io('/marriage', sharedOptions);

export let socket: Socket = sketchSocket;
let activeMode: GameMode = 'sketch';

export function selectGameSocket(mode: GameMode): Socket {
  const next = mode === 'who-said' ? whoSaidSocket : mode === 'story' ? storySocket : mode === 'blind' ? blindSocket : mode === 'marriage' ? marriageSocket : sketchSocket;
  if (socket !== next && socket.connected) socket.disconnect();
  socket = next;
  activeMode = mode;
  if (!socket.connected) socket.connect();
  return socket;
}

export function disconnectActiveSocket() {
  if (socket.connected) socket.disconnect();
}

export function currentGameMode(): GameMode {
  return activeMode;
}
